import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first, groupBy, map, mergeMap, of, reduce, toArray } from 'rxjs';
import {
  crop_Datas,
  FarmerLandModel,
  FLandModel,
} from 'src/app/models/farmer-land.model';
import { TankCoverageArea } from 'src/app/models/farmers-application.model';
import { OnFarmMiModel } from 'src/app/models/on-farm-mi.model';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BankDetailService } from 'src/app/services/bank-details.service';
import { ChallanService } from 'src/app/services/challan-services.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { FarmerLandDetailService } from 'src/app/services/farmer-land-detail.service';
import { FarmersApplicationService } from 'src/app/services/farmers-application.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { OnFarmMiService } from 'src/app/services/on-farm-mi.service';
import { BankDetail } from '../../registration/bank-details/bankDetails';

@Component({
  selector: 'app-change-request',
  templateUrl: './change-request.component.html',
  styleUrls: ['./change-request.component.scss'],
})
export class ChangeRequestComponent implements OnInit {
  public farmerId: any;
  public farmerMobile: any;
  public farmerAppDetails: any;

  requestType: any = [
    { reqType: 'Personal Details' },
    { reqType: 'Bank Details' },
    { reqType: 'Land Details' },
    { reqType: 'Existing MI Details' },
    { reqType: 'Edit App Details' },
  ];

  public todayDate: Date;
  public famerAppDetailsforDropDown: any = [];
  public selectedFarmerDeatils: any;
  public selectedAppId: any;

  public selectedRequestType: any;

  public showPersonalDetailsCard: boolean = false;
  public showBankDetailsCard: boolean = false;
  public showLandDetailsCard: boolean = false;
  public showExistingMIDetailsCard: boolean = false;
  public showEditAppDetailsCard: boolean = false;

  //personal details
  public farmersDetailsForm: FormGroup;
  // public selectedVillage: any;
  public selectedVillageForPersonalDetails: any;
  public selectedVillageForEditAppDetails: any;
  public selectedVillageForLandDetails: any;
  public isPeronalDetailsSubmitted: boolean = false;
  public genderType: string;
  public filteredVillage: any[];
  public villageList: { Code: number; Name: string }[];

  //bank details
  bankAccountList: BankDetail[] = [];
  bankAccountListForEditApp: BankDetail[] = [];
  bankList: any;
  selectedBankAccounts: BankDetail[];
  openBankDialog: boolean = false;
  bankAccount: any = [];
  bankDetailsSubmitted: boolean = false;
  filteredBankList: any[];
  public bank_Name: any;

  //land details
  lstFarmerLandModel: FarmerLandModel[];
  selectedFarmerLand: FarmerLandModel[];
  landDetailsSubmitted: boolean = false;
  openLandDialog: boolean = false;
  public innerWidth: any;
  public farmerLandForm: FormGroup;
  selectedNodes1: any[] = [];
  nodes2: any[];
  valRadio: boolean;
  selectedCorpModel: crop_Datas;
  selectedCorpModelList: any;
  farmerLandModel: FarmerLandModel;
  editFLModel: FarmerLandModel;

  // Existing MI Details
  lstOnFarmMiModel: OnFarmMiModel[];
  selectedOnFarmMi: OnFarmMiModel[];
  editFarmMiModel: OnFarmMiModel;
  lstFarmerLandModel1: FLandModel[];
  selectedLandDetail: any;
  selectedcompMaster: any;
  componentMasterList = [];
  isSubsidyAvailabe: any;
  openExistingMIDialog: boolean = false;
  public onFarmMIForm: FormGroup;
  existingMIDetailsSubmitted: boolean = false;
  filteredLandDetails: any[];
  MorabbaNo: any;
  KillaNo: any;
  filteredComponentMaster: any[];
  departmentList = [
    { name: 'Agriculture', code: 'Agriculture' },
    { name: 'Horticulture', code: 'Horticulture' },
  ];
  onFarmMiModel: OnFarmMiModel;

  // Edit App Details
  applicationSelected: any;
  waterSourceTypeList: { waterSource: any; component: any[] }[] = [];
  schemeMasterList: { type: any; data: any[] }[];
  componentList: any = [];
  canalOutletList: { canal: any; data: any[] }[];
  villageCodeFarmer = [];
  selectedVillageName: any;
  selectedVillageCode: any;
  selectedFarmerLandDetails: any[];
  farmerDetailsList: any;
  applicationId: any;
  landIDList: any;
  allLandsOfApplication: any;
  selectedFarmersLandList: any[];
  outletTypeList: any[];
  selectedWatersourceType: any;
  watercourseApplicatonForm: FormGroup;
  selectedLandIdList: any;
  componentSelected: any;
  addFarmerGroupDialog: boolean = false;
  consentUploadPath: any;
  miApplicatonForm: FormGroup;
  addBankDialog: boolean = false;
  miDetailsList = [];
  onFarmPondApplicatonForm: FormGroup;
  public isSubmittedWaterCourseFrom: boolean = false;
  public isSubmittedPondApplicatonForm: boolean = false;
  public isSubmittedSolarApplicatonFrom: boolean = false;
  tankListMaster: any;
  coverageAreaSelected: TankCoverageArea = new TankCoverageArea();
  solarApplicatonForm: FormGroup;
  primarySolarVendorList = [];
  solarMasterData: any = [];
  selectedPrimarySolarVendor: any;
  secondarySolarVendorList = [];
  selectedSecondarySolarVendor: any;
  selectedSecondarySolarVendorId: any;
  pumpCapacityList: { name: string; code: string }[];
  workTypeMasterList: any;
  bankAccountSelected: any;
  farmerPreviousSubsidies: any = [];
  totalNumberOfFarmersInGroup: number;
  selectedGroupFarmersLandList: any[];
  selectedSchemeId: any;
  selectedPondLand: any;
  allSchemeMaster: any[] = [];

  miList: any = [];
  public selectedMI: any;
  public selectedProgramId: any;
  miVendorList: any = [];
  filteredmiVendorList: any = [];
  miSelectedVendor: any;
  selectedFarmersLandIdList: any[] = [];
  componentMaster: any;

  ipAddress: any = '000.000.000';


  constructor(
    private messageService: MessageService,
    private _fb: FormBuilder,
    private _personalDetalSer: FarmersDetailsService,
    private productService: BankDetailService,
    private flService: FarmerLandDetailService,
    private ofService: OnFarmMiService,
    private farmerAppSer: FarmersApplicationService,
    private confirmationService: ConfirmationService,
    private _dashboardService: DashboardService,
    private activityRecordService : ActivityRecordService,
    private loader: AppLoaderService,
    private ipService: IpAddressService,
  ) {}

  ngOnInit(): void {
    this.todayDate = new Date();
    this.getIP();
    this.farmerId = sessionStorage.getItem('farmerId');
    this.farmerMobile = sessionStorage.getItem('farmerPh');

    this.activityRecordService.activityRecord(this.farmerMobile, 'Change Request', this.farmerId, new Date(), 'Success');


    this.farmersDetailsForm = this._fb.group({
      farmersName: ['', Validators.required],
      fathersName: ['', Validators.required],
      mothersName: ['', Validators.required],
      gender: ['', Validators.required],
      dob: ['', Validators.required],
      pppId: [
        '',
        [Validators.required, Validators.minLength(8), Validators.maxLength(8)],
      ],
      aadharNo: [
        '',
        [
          Validators.required,
          Validators.minLength(12),
          Validators.maxLength(12),
        ],
      ],
      aadharPhotoPath: ['', Validators.required],
      mobileNo: [
        '',
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      caste: ['', Validators.required],
      address: ['', Validators.required],
      pincode: ['', Validators.required],
      emailId: [
        '',
        Validators.compose([Validators.required, Validators.email]),
      ],
      village: [this.selectedVillageForPersonalDetails, Validators.required],
      pppPhotoPath: ['', Validators.required],
      farmersPhotoPath: ['', Validators.required],
    });

    this._personalDetalSer.getVillageMatserData().subscribe((res) => {
      console.log(res);
      this.villageList = res;
      this.filteredVillage = [...this.villageList];
      if (!window.sessionStorage.getItem('villageMaster')) {
        window.sessionStorage.setItem('villageMaster', JSON.stringify(res));
      }
    });

    this.farmerLandForm = this._fb.group({
      totalArea: ['', [Validators.required]],
      morabbaNumber: [, [Validators.required]],
      killaNumber: [, [Validators.required]],
      kanals: [
        '',
        Validators.compose([Validators.required, Validators.max(8)]),
      ],
      marlas: ['', [Validators.required]],
      village: ['', [Validators.required]],
      latitude: ['', ''],
      longitude: ['', ''],
      cropType: ['', [Validators.required]],
      IsSubsidyAvailabe: ['', [Validators.required]],
      landdoc_Path: ['', [Validators.required]],
      leaseDoc_Path: [''],
    });

    this.onFarmMIForm = this._fb.group({
      yearSubsudy: ['', []],
      balanceArea: ['', [Validators.required]],
      departmentSubsidy: ['', []],
      componentMaster: ['', []],
      isSubsidyAvailabe: ['', [Validators.required]],
      landDetails: ['', [Validators.required]],
      subsidyArea: [''],
    });

    //edit app
    this.watercourseApplicatonForm = this._fb.group({
      canal: ['', Validators.required],
      outlet: ['', Validators.required],
      workType: ['', Validators.required],
      checkBox: ['', Validators.required],
    });

    this.miApplicatonForm = this._fb.group({
      mi: [''],
      vendor: [''],
      landId: [''],
    });

    this.onFarmPondApplicatonForm = this._fb.group({
      landId: ['', Validators.required],
      sizeCoverageArea: ['', Validators.required],
      topSize: [''],
      bottomSize: [''],
      depth: [''],
      waterCapacity: [''],
      tenativeCost: [''],
      tankId: [''],
    });

    this.solarApplicatonForm = this._fb.group({
      controlType: ['', Validators.required],
      pump: ['', Validators.required],
      pumpType: ['', Validators.required],
      pumpCapacity: ['', Validators.required],
      primaryVendor: ['', Validators.required],
      secondaryVendor: [''],
      farmerShare: [''],
      solarId: ['', Validators.required],
      landId: ['', Validators.required],
    });

    this.pumpCapacityList = [
      { name: '3 HP', code: '3 HP' },
      { name: '5 HP', code: '5 HP' },
      { name: '7.5 HP', code: '7.5 HP' },
      { name: '10 HP', code: '10 HP' },
    ];
  }

  //App details API
  getApplicationIdsForChallan(farmerId) {
    this.loader.start();
    this.farmerAppSer
      .getApplicationIdsByFarmerIdForCR(farmerId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.farmerAppDetails = res;
          console.log('farmerAppDetails', this.farmerAppDetails);
          if (this.farmerAppDetails.length > 0) {
            this.famerAppDetailsforDropDown = this.farmerAppDetails;
            // this.famerAppDetailsforDropDown = this.farmerAppDetails.map(
            //   (res) => {
            //     return {
            //       appIdToDisplay: res.AppId + ' (' + res.ProgrammeName + ')',
            //       ...res,
            //     };
            //   }
            // );
          }
          console.log(
            'famerAppDetailsforDropDown',
            this.famerAppDetailsforDropDown
          );
        },
        error: (err) => {
          this.loader.close();

          console.log('error', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  // On select App Id
  onSelectAppId() {
    console.log('selected farmer details', this.selectedFarmerDeatils);
    this.selectedAppId = this.selectedFarmerDeatils;
    console.log('selected app ID', this.selectedAppId);
    this.applicationId = this.selectedAppId;
    // this.applicationId = "MI22230000099";
    this.populateForm(this.applicationId);
  }

  hideAllCards() {
    this.showPersonalDetailsCard = false;
    this.showBankDetailsCard = false;
    this.showLandDetailsCard = false;
    this.showExistingMIDetailsCard = false;
    this.showEditAppDetailsCard = false;
  }

  // on select change request type
  onSelectChangeRequestType() {
    this.hideAllCards();
    console.log('onSelectChangeRequestType', this.selectedRequestType);
    this.selectedRequestType.forEach((value) => {
      if (value.reqType == 'Personal Details') {
        this.LoadFarmerDetails();
        this.showPersonalDetailsCard = true;
      }
      if (value.reqType == 'Bank Details') {
        this.getFarmerId();
        this.getBankNameList();
        this.showBankDetailsCard = true;
      }
      if (value.reqType == 'Land Details') {
        this.loadLandDetailsData();
        this.getCorpType();
        this.innerWidth = window.innerWidth;
        this.showLandDetailsCard = true;
      }
      if (value.reqType == 'Existing MI Details') {
        this.loadOnFramMI();
        // this.getCorpType();
        this.loadComponentMaster();
        this.loadExisitingMIDialogData();
        this.innerWidth = window.innerWidth;
        this.showExistingMIDetailsCard = true;
      }

      if (value.reqType == 'Edit App Details') {
        this.getApplicationIdsForChallan(this.farmerId);
        // this.applicationId = "MI22230000099"
        this.waterSourceTypeList = [];
        // this.innerWidth = window.innerWidth;
        this.getPastSubsidiesByFarmerId();
        this.getSchemeMaster();
        this.getSolarMaster();
        this.getComponentMaster();
        this.getWorkTypeMasterData();
        this.getAllTank();
        
        this.getBankListOfFarmer();
        this.getVillageData();

        this.showEditAppDetailsCard = true;
      }
    });
  }
  //----------------------------------------------------------------------------------

  // Personal Details
  get farmersFormControls() {
    return this.farmersDetailsForm.controls;
  }

  onUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);
    let phNo = sessionStorage.getItem('farmerPh');
    this.loader.start();

    this._personalDetalSer
      .uploadFile(data, phNo, formcontrol)
      .subscribe((resp: any) => {
        this.loader.close();

        console.log(resp);
        if (resp.statusCode == 200) {
          this.farmersDetailsForm.patchValue({ [formcontrol]: resp.data });
          console.log(this.farmersDetailsForm);
        }
      });
    uploadElement.clear();
  }

  filterVillage(event: any) {
    console.log(event);
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.villageList.length; i++) {
      const village = this.villageList[i];
      if (village.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(village);
      }
    }

    this.filteredVillage = filtered;
    console.log(this.filteredVillage);
  }

  LoadFarmerDetails() {
    let phNo = sessionStorage.getItem('farmerPh');
    this.loader.start();
    this._personalDetalSer
      .getFarmerDetails(phNo)
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (data) {
            this.loader.close();
            let farmerData = data.Table[0];
            if (farmerData) {
              // this.isEditable = farmerData.IsEdit;
              let dob = farmerData.DOB.split('T')[0].split('-');
              console.log(dob);

              console.log(dob[2] + '-' + dob[1] + '-' + dob[0]);

              this.farmersFormControls.pppId.setValue(farmerData.PPP_ID);
              this.farmersFormControls.farmersName.setValue(farmerData.Name);
              this.farmersFormControls.fathersName.setValue(
                farmerData.Father_name
              );
              this.farmersFormControls.mothersName.setValue(
                farmerData.Mother_Name
              );
              this.farmersFormControls.address.setValue(farmerData.Address);
              this.farmersFormControls.mobileNo.setValue(farmerData.Mobile);
              this.farmersFormControls.dob.setValue(
                dob[2] + '-' + dob[1] + '-' + dob[0]
              );
              // this.farmersFormControls.dob.setValue(farmerData.DOB);
              this.farmersFormControls.pincode.setValue(farmerData.Pin_Code);
              this.farmersFormControls.emailId.setValue(farmerData.Email_ID);
              this.farmersFormControls.aadharNo.setValue(farmerData.Aadhar_No);
              this.farmersFormControls.caste.setValue(farmerData.Caste_Code);
              // this.farmersFormControls.idProof.setValue(farmerData.IDproof_Type);
              this.farmersFormControls.gender.setValue(farmerData.Gender);
              this.genderType = farmerData.Gender;
              this.farmersFormControls.farmersPhotoPath.setValue(
                farmerData.Farmer_Photo
              );
              // this.farmersFormControls.idProofPhotoPath.setValue(farmerData.ID_Proof_FilePath);
              this.farmersFormControls.aadharPhotoPath.setValue(
                farmerData.Aadhaar_Copy_Upload
              );
              this.farmersFormControls.pppPhotoPath.setValue(
                farmerData.ID_Proof_FilePath
              );
              console.log(this.farmersFormControls.dob.value);
              let village = this.villageList.filter(
                (val) => val.Code === farmerData.Village_Code
              )[0];
              this.farmersFormControls.village.setValue(village.Name);
              this.selectedVillageForPersonalDetails = village;
            }
          }
        },
        error: () => {
          this.loader.close();
          this.farmersFormControls.mobileNo.setValue(phNo);
          // this.router.navigate(['/personal-details']);
        },
      });
  }

  onPersonDetailUpdate() {
    this.isPeronalDetailsSubmitted = true;
    console.log(this.farmersDetailsForm);

    if (this.farmersDetailsForm.valid) {
      // console.log(this.mapDataToFarmersModel());
      // const data = this.mapDataToFarmersModel();
      // let farmerData = JSON.parse(window.sessionStorage.getItem('farmerDetails'));
      // if (farmerData) {
      //   console.log(data);

      //   this._update(data)
      // } else {
      //   this._insert(data)
      // }
      // /api/ChangeRequest/PersonalDetailsInsert_CR

      let DOB: Date;
      let values = this.farmersDetailsForm.controls.dob.value
        .toString()
        .split('-');
      if (values.length) {
        //Replacing DD MM to MM DD Format.
        values.splice(1, 0, values.shift());
        DOB = values.join(' ');
      }

      let val = this.farmersDetailsForm.value;
      console.log('Value', val);
      let reqBody = {
        farmerID: this.farmerId,
        name: val.farmersName,
        farmerFatherName: val.fathersName,
        farmerMotherName: val.mothersName,
        gender: val.gender,
        dob: DOB
          ? this.toISOLocal(new Date(DOB)).replace(/.\d+Z$/g, '')
          : this.toISOLocal(
              new Date(this.farmersDetailsForm.controls.dob.value)
            ).replace(/.\d+Z$/g, ''),
        farmerphoto_path: val.farmersPhotoPath,
        ppP_ID: val.pppId,
        aadharno: val.aadharNo,
        mobileno: val.mobileNo,
        castcode: val.caste,
        address: val.address,
        pincode: val.pincode,
        emailid: val.emailId,
        villagecode: val.village.Code,
        ppP_path: val.pppId,
        aadhar_path: val.aadharPhotoPath,
        active: '1',
        area_Already_Apply: 0,
        userID: sessionStorage.getItem('abyUserID')
          ? sessionStorage.getItem('abyUserID')
          : sessionStorage.getItem('userID'),
        network_ID: this.ipAddress,
        terminal_ID: this.ipAddress,
      };

      this.personalDetailsInsert_CR(reqBody);
    }
  }

  toISOLocal(d) {
    var z = (n) => ('0' + n).slice(-2);
    var off = d.getTimezoneOffset();
    off = Math.abs(off);

    return d.getFullYear() + '-' + z(d.getMonth() + 1) + '-' + z(d.getDate());
  }

  personalDetailsInsert_CR(reqBody) {
    this.loader.start();
    this.farmerAppSer
      .personalDetailsInsert_CR(reqBody)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          this.loader.close();
          this.messageService.add({
            severity: 'success',
            summary: 'Success Message',
            detail: resp,
          });
          // this.showPersonalDetailsCard = false;
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  //----------------------------------------------------------------------------------

  // Bank Details
  editBankDetails(product) {
    console.log('selected bank details row for edit', product);
    this.bankAccount = product;
    // Bank_ID
    console.log('banklist', this.bankList);
    let bankName = this.bankList.filter(
      (val) => val.BANK_ID === product.Bank_ID
    )[0];
    console.log(bankName);
    // this.selectedBankAccounts = bankName;
    this.bank_Name = bankName;
    this.openBankDialog = true;
  }

  getBankList() {
    this.loader.start();
    this.productService
      .getBankDetails(this.farmerId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          let d = data ?? [];
          this.bankAccountList = d.map((res) => {
            return {
              accountHolderName: res.Account_Holder_Name,
              accountNumber: res.Account_NO,
              bankName: this.bankList
                .filter((d) => d.BANK_ID === res.Bank_ID)
                .map((d) => d.Bank_NAME)[0],
              ifscCode: res.IFSC_code,
              image: res.Passbook_Copy_Upload,
              ...res,
            };
          });
          console.log(this.bankAccountList);

          // this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Farmer Bank Details saved Successfully.' });
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Farmer Bank Details not loaded.',
          });
        },
      });
  }

  getFarmerId() {
    let mobile = sessionStorage.getItem('farmerPh');
    this.loader.start();
    this.productService.getFarmerIdByMobileNo(mobile).subscribe((resp) => {
      this.loader.close();
      if (resp.statusCode === 200) {
        let far = JSON.parse(resp.data);
        if (far.length > 0) {
          this.farmerId = far[0].Farmer_ID;
          console.log(this.farmerId);

          this.getBankList();
        }
      }
    });
  }

  getBankNameList() {
    this.loader.start();
    this.productService.getAllBankNames().subscribe((data) => {
      this.loader.close();
      if (data) {
        this.bankList = data;
        this.filteredBankList = data;
        console.log(this.bankList);
      }
    });
  }

  filterBank(event: any) {
    console.log(event);

    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.bankList.length; i++) {
      const bank = this.bankList[i];
      if (bank.Bank_NAME.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(bank);
      }
    }

    this.filteredBankList = filtered;
    console.log(this.filteredBankList);
  }

  hideBankDialog() {
    this.openBankDialog = false;
    this.bankDetailsSubmitted = false;
  }

  saveBankDetails() {
    this.bankDetailsSubmitted = true;
    console.log(this.bankAccount);
    console.log('bank_Name', this.bank_Name);

    if (
      this.bankAccount.accountHolderName!.trim() &&
      this.bankAccount.accountNumber &&
      this.bankAccount.bankName &&
      this.bankAccount.ifscCode &&
      this.bankAccount.image &&
      this.bank_Name
    ) {
      const data = {
        farmerID: this.farmerId,
        bankID: this.bank_Name.BANK_ID,
        ifcS_Code: this.bankAccount.ifscCode,
        acco_Number: this.bankAccount.accountNumber.toString(),
        accHoName: this.bankAccount.accountHolderName,
        scanCopy_Path: this.bankAccount.image,
        active: '1',
        user_ID: sessionStorage.getItem('abyUserID')
          ? sessionStorage.getItem('abyUserID')
          : sessionStorage.getItem('userID'),
        network_Id: this.ipAddress,
        terminal_ID: this.ipAddress,
      };
      this.loader.start();
      this.productService
        .bankDetailsInsert_CR(data)
        .pipe(first())
        .subscribe({
          next: (resp) => {
            this.loader.close();
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: 'Bank Details Added',
            });
            this.getBankList();
          },
          error: (err) => {
            this.loader.close();
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: err,
            });
          },
        });
      this.openBankDialog = false;
      this.bankAccount = {};
    }
  }
  //----------------------------------------------------------------------------------

  // Land Details
  get f() {
    return this.farmerLandForm.controls;
  }

  loadLandDetailsData() {
    this.loader.start();
    this.flService
      .Get(this.farmerId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data.Table.length > 0) {
            this.lstFarmerLandModel = data.Table;
            console.log('this.lstFarmerLandModel', this.lstFarmerLandModel);
          }
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Farmer Land Details not loaded.',
          });
        },
      });
  }

  editLandDetails(bank: any) {
    console.log('selected land details', bank);
    this.editFLModel = new FarmerLandModel();
    console.log('selected land details', this.f.value);

    let farmerData = JSON.parse(window.sessionStorage.getItem('farmerDetails'));
    let flModel = { ...bank };
    this.f.totalArea.setValue(flModel.Total_Area);
    this.f.morabbaNumber.setValue(flModel.Morabba_No);
    this.f.killaNumber.setValue(flModel.Killa_No);
    this.f.kanals.setValue(flModel.Kanals);

    this.f.marlas.setValue(flModel.Marlas);

    this.f.latitude.setValue(flModel.Lat);
    this.f.longitude.setValue(flModel.Long);
    this.valRadio = flModel.IS_Avalibe_for_Lease;
    this.f.cropType.setValue(flModel.Crop_Type_ID);
    this.f.landdoc_Path.setValue(flModel.Land_Doc);
    this.editFLModel = flModel;

    let village = this.villageList.filter(
      (val) => val.Code === flModel.Village_Code
    )[0];
    this.f.village.setValue(village.Name);
    this.selectedVillageForLandDetails = village;

    this.openLandDialog = true;
  }

  onKanalsChange() {
    let tlk: any = 0.0;
    let tlm: any = 0.0;
    if (this.f.kanals.value != undefined || this.f.kanals.value != '') {
      if (parseInt(this.f.kanals.value) >= 8) {
        this.f.marlas.setValue(0);
        this.f.marlas.disable();
        tlm = 1;
      } else {
        this.f.marlas.enable();
      }
      tlk = parseInt(this.f.kanals.value) * 0.125;
    }
    if (this.f.marlas.value != undefined || this.f.marlas.value != '') {
      tlk = parseInt(this.f.marlas.value) * 0.006249999998;
    }

    let tl = tlk + tlm;
    this.f.totalArea.setValue(parseFloat(tl).toFixed(2));
  }

  onMarlasChange() {
    let tlk: any = 0.0;
    let tlm: any = 0.0;
    if (this.f.kanals.value != undefined || this.f.kanals.value != '') {
      tlk = parseInt(this.f.kanals.value) * 0.125;
    }
    if (this.f.marlas.value != undefined || this.f.marlas.value != '') {
      tlm = parseInt(this.f.marlas.value) * 0.006249999998;
    }
    let tl = tlk + tlm;
    this.f.totalArea.setValue(parseFloat(tl).toFixed(2));
  }

  getCorpType() {
    this.loader.start();
    this.flService
      .GetCorpType()
      .pipe(first())
      .subscribe({
        next: (files) => {
          this.loader.close();
          this.nodes2 = files;
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Corp Type Details not loaded.',
          });
        },
      });
  }

  setCurrentPosition() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.showPosition(position);
      });
    }
  }

  showPosition(position) {
    let geocoder = new google.maps.Geocoder();
    let latlng = {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    };
    this.f.latitude.setValue(position.coords.latitude);
    this.f.longitude.setValue(position.coords.longitude);
  }

  getSelectedCorpType() {
    this.selectedCorpModel = new crop_Datas();
    this.selectedCorpModelList = [];
    let selectedLabels = [];
    for (let result of this.selectedNodes1) {
      if (result.parent) {
        if (selectedLabels.includes(result.label)) {
          break;
        }
        let body = {
          crop_ID: result.data,
          type_of_crop_ID: result.parent?.data,
        };
        this.selectedCorpModelList.push(body);
        selectedLabels.push(result.label);
      } else if (result.children) {
        result.children.forEach((child) => {
          if (selectedLabels.includes(child.label)) {
            return;
          }
          let body = {
            crop_ID: child.data,
            type_of_crop_ID: child.parent?.data
              ? child.parent?.data
              : result.data,
          };

          this.selectedCorpModelList.push(body);
          selectedLabels.push(child.label);
        });
      }
    }
    console.log('Crop Datas: ', this.selectedCorpModelList);
  }

  onLandDetailsSubmit() {
    this.landDetailsSubmitted = true;

    // stop here if form is invalid
    if (this.farmerLandForm.invalid) {
      return;
    }
    let farmerData = JSON.parse(window.sessionStorage.getItem('farmerDetails'));
    if (!farmerData) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Please complete the farmer details first.',
      });
      return;
    }
    this.getSelectedCorpType();
    this.farmerLandModel = new FarmerLandModel();
    this.farmerLandModel.land_ID = 0;
    this.farmerLandModel.farmerID = this.farmerId;
    this.farmerLandModel.total_Area = this.f.totalArea.value;
    this.farmerLandModel.morbno = this.f.morabbaNumber.value;
    this.farmerLandModel.killano = this.f.killaNumber.value;
    this.farmerLandModel.kanal = this.f.kanals.value;
    this.farmerLandModel.marla = this.f.marlas.value;
    this.farmerLandModel.village_Code = this.f.village.value.Code;
    this.farmerLandModel.lat = this.f.latitude.value
      ? this.f.latitude.value
      : 0;
    this.farmerLandModel.long = this.f.longitude.value
      ? this.f.longitude.value
      : 0;
    this.farmerLandModel.is_Available_Lease = this.valRadio;
    this.farmerLandModel.landdoc_Path = this.f.landdoc_Path.value;
    this.farmerLandModel.lease_Agrement_Doc = this.valRadio
      ? this.f.leaseDoc_Path.value
      : '';
    this.farmerLandModel.user_ID = farmerData.Farmer_ID;
    this.farmerLandModel.network_ID = this.ipAddress;
    this.farmerLandModel.terminal_ID = this.ipAddress;
    this.farmerLandModel.active = '1';
    this.farmerLandModel.crop_Datas = this.selectedCorpModelList;

    if (this.editFLModel.Land_ID > 0) {
      this.farmerLandModel.land_ID = this.editFLModel.Land_ID;
      this.loader.start();
      this.flService
        .landDetailsInsert_CR(this.farmerLandModel)
        .pipe(first())
        .subscribe({
          next: () => {
            this.loader.close();
            this.loadLandDetailsData();
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: 'Farmer Land saved Successfully.',
            });
            this.openLandDialog = false;
            this.farmerLandForm.reset();
          },
          error: () => {
            this.loader.close();
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Data error! Farmer Land Details not saved.',
            });
          },
        });
    } else {
      this.loader.start();
      this.flService
        .InsertLandDetails(this.farmerLandModel)
        .pipe(first())
        .subscribe({
          next: () => {
            this.loader.close();
            this.loadLandDetailsData();
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: 'Farmer Land saved Successfully.',
            });
            this.openLandDialog = false;
          },
          error: () => {
            this.loader.close();
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Data error! Farmer Land Details not saved.',
            });
          },
        });
    }
  }

  hideLandDialog() {
    this.openLandDialog = false;
    this.landDetailsSubmitted = false;
  }

  //----------------------------------------------------------------------------------

  // Existing MI Details
  get fMI() {
    return this.onFarmMIForm.controls;
  }

  loadOnFramMI() {
    let farmerData = JSON.parse(window.sessionStorage.getItem('farmerDetails'));
    this.loader.start();
    if (!farmerData) {
      this.loader.close();
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Please complete the farmer details first.',
      });
      return;
    }
    this.farmerId = farmerData?.Farmer_ID;

    this.ofService
      .GetOnFarmMi(farmerData.Farmer_ID)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data.Table.length > 0) {
            this.lstOnFarmMiModel = data.Table.map((res) => {
              return {
                landDetailsToDisplay:
                  'Village Name:' +
                  res.VillageName +
                  ' - Killa No:' +
                  res.Killa_No +
                  ' - Morabba No:' +
                  res.Morabba_No,
                ...res,
              };
            });
          }
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Farm Mi Details not loaded.',
          });
        },
      });
  }

  loadExisitingMIDialogData() {
    let farmerData = JSON.parse(window.sessionStorage.getItem('farmerDetails'));
    if (farmerData) {
      this.loader.start();
      this.flService
        .getNotUsedLandsByFarmerID(farmerData.Farmer_ID)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.loader.close();
            if (data.length > 0) {
              this.lstFarmerLandModel1 = data;
              this.lstFarmerLandModel1.forEach(function (value) {
                value.description =
                  'Morabba: ' + value.MorabbaNo + ', Killa' + value.KillaNo;
              });
            } else {
              this.loader.close();
              this.messageService.add({
                severity: 'info',
                summary: 'Info Message',
                detail: data,
              });
            }
          },
          error: (err) => {
            this.loader.close();
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Data error! Farmer Land Details not loaded.',
            });
          },
        });
    }
  }

  editExistingMIDetails(bank: any) {
    this.openExistingMIDialog = true;
    this.editFarmMiModel = new OnFarmMiModel();
    let farmerData = JSON.parse(window.sessionStorage.getItem('farmerDetails'));
    let farmMi = { ...bank };
    console.log('seleceted row details', farmMi);
    this.fMI.yearSubsudy.setValue(farmMi.Year_subsidy);
    this.fMI.balanceArea.setValue(farmMi.Bal_Area);
    this.fMI.departmentSubsidy.setValue(farmMi.Dept_Subsidy);
    this.fMI.landDetails.setValue(farmMi.Land_ID);
    let val = this.lstFarmerLandModel1.filter(
      (x) => x.LandID == farmMi.Land_ID
    )[0];
    this.selectedLandDetail = val;
    this.fMI.componentMaster.setValue(farmMi.Component);
    this.selectedcompMaster = this.componentMasterList.filter(
      (x) => x.Program_Name == farmMi.Component
    )[0];
    this.isSubsidyAvailabe = farmMi.Is_Subsidy_Avail;
    this.editFarmMiModel = bank;

    // this.openExistingMIDialog = true;
  }

  filterLandDetails(event: any) {
    console.log(event);
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.lstFarmerLandModel1.length; i++) {
      const wq = this.lstFarmerLandModel1[i];
      if (wq.MorabbaNo.toString().indexOf(query) == 0) {
        filtered.push(wq);
      }
    }
    this.filteredLandDetails = filtered;
    console.log(this.filteredLandDetails);
  }

  changeLD() {
    this.KillaNo = this.selectedLandDetail.KillaNo;
    this.MorabbaNo = this.selectedLandDetail.MorabbaNo;
    let balanceArea =
      this.selectedLandDetail.TotalArea - this.fMI.balanceArea.value;
    this.fMI.balanceArea.setValue(balanceArea);
  }

  loadComponentMaster() {
    this.loader.start();
    this.farmerAppSer.getComponentMaster().subscribe((res) => {
      this.loader.close();
      this.componentMasterList = res;
      this.filteredComponentMaster = [...this.componentMasterList];
    });
  }

  filterComponentMaster(event: any) {
    console.log(event);

    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.componentMasterList.length; i++) {
      const wq = this.componentMasterList[i];
      if (wq.Program_Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(wq);
      }
    }

    this.filteredComponentMaster = filtered;
    console.log(this.filteredComponentMaster);
  }

  subsidyAreachange(event: any) {
    console.log(
      'this.selectedLandDetail.Total_Area',
      this.selectedLandDetail?.Total_Area
    );
    let balanceArea =
      this.selectedLandDetail?.Total_Area - this.fMI.subsidyArea.value;
    this.fMI.balanceArea.setValue(balanceArea);
  }

  hideExistingMIDialog() {
    this.openExistingMIDialog = false;
    this.existingMIDetailsSubmitted = false;
  }

  onExistingMISubmit() {
    this.existingMIDetailsSubmitted = true;
    this.loader.start();
    // stop here if form is invalid
    if (this.onFarmMIForm.invalid) {
      return;
      this.loader.close();
    }
    let farmerData = JSON.parse(window.sessionStorage.getItem('farmerDetails'));
    if (!farmerData) {
      this.loader.close();
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Please complete the farmer details first.',
      });
      return;
    }

    this.onFarmMiModel = new OnFarmMiModel();
    this.onFarmMiModel.farmerID = farmerData.Farmer_ID;
    this.onFarmMiModel.land_ID = this.fMI.landDetails.value.LandID;
    this.onFarmMiModel.water_Quality = '1';
    this.onFarmMiModel.isSubsidyAvail = this.isSubsidyAvailabe;
    this.onFarmMiModel.year_subsidy =
      this.isSubsidyAvailabe == 1 ? this.fMI.yearSubsudy.value : '0';
    this.onFarmMiModel.bal_Area = this.fMI.balanceArea.value;
    this.onFarmMiModel.dept_subsidy =
      this.isSubsidyAvailabe == 1 ? this.fMI.departmentSubsidy.value : '';
    this.onFarmMiModel.component = this.fMI.componentMaster.value.Program_Id;
    this.onFarmMiModel.user_ID = sessionStorage.getItem('abyUserID')
      ? sessionStorage.getItem('abyUserID')
      : sessionStorage.getItem('userID');
    this.onFarmMiModel.network_ID = this.ipAddress;
    this.onFarmMiModel.terminal_ID = this.ipAddress;

    console.log("this.editFarmMiModel", this.editFarmMiModel)
    // if (this.editFarmMiModel != null) {
      this.onFarmMiModel.farmerID = this.editFarmMiModel.Farmer_ID;
      this.onFarmMiModel.land_ID = this.editFarmMiModel.Land_ID;
      this.ofService
        .insertOnFarmMIDetails_CR(this.onFarmMiModel)
        .pipe(first())
        .subscribe({
          next: () => {
            this.loader.close();
            this.loadOnFramMI();
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: 'Farm Mi saved Successfully.',
            });
            this.openExistingMIDialog = false;
          },
          error: () => {
            this.loader.close();
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Data error! Farm Mi Details not saved.',
            });
          },
        });
    // } else {
    //   this.ofService
    //     .insertOnFarmMIDetails_CR(this.onFarmMiModel)
    //     .pipe(first())
    //     .subscribe({
    //       next: () => {
    //         this.loadOnFramMI();
    //         this.messageService.add({
    //           severity: 'success',
    //           summary: 'Success Message',
    //           detail: 'Farm Mi saved Successfully.',
    //         });
    //         this.openExistingMIDialog = false;
    //       },
    //       error: () => {
    //         this.messageService.add({
    //           severity: 'error',
    //           summary: 'Error Message',
    //           detail: 'Data error! Farm Mi Details not saved.',
    //         });
    //       },
    //     });
    // }
  }
  //--------------------------------------------------------------------------------------------------

  
  // Edit App details
  //-------------------------------------------------------------------------------------
  onApplicationTypeSelected(event) {
    let selected = event.value;
    // this.getVillageData();
    this.applicationSelected = selected;
    this.waterSourceTypeList = [];
    this.componentList = [];
    let selectedAppData = this.schemeMasterList.filter(
      (d) => d.type === this.applicationSelected
    )[0].data;
    this.loader.start();
    of(...selectedAppData)
      .pipe(
        groupBy((p: any) => p.Source_Name),
        mergeMap((group$) =>
          group$.pipe(reduce((acc, cur) => [...acc, cur], [`${group$.key}`]))
        ),
        map((arr) => ({ waterSource: arr[0], component: arr.slice(1) })),
        toArray()
      )
      .subscribe((p) => {
        this.loader.close();
        this.waterSourceTypeList = p;
        if (this.applicationSelected == 'Individual') {
          // this.listAllOutletData();
        } else {
          this.canalOutletList = [];
        }
      });
  }

  onVillageSelect(val: any) {
    this.villageCodeFarmer = [];
    this.selectedVillageName = val.Name;
    this.selectedVillageCode = val.Code;
    this.selectedVillageForEditAppDetails = val;
    this.selectedFarmerLandDetails = [];
    this.farmerDetailsList = [];
    this.villageCodeFarmer.push(val.Code);
    this.GetAllFarmerDetails(this.villageCodeFarmer);
    this.getAllOutletData(this.villageCodeFarmer);
  }

  GetAllFarmerDetails(villageCode: any) {
    this.selectedFarmerLandDetails = [];
    this.farmerDetailsList = [];
    if (this.applicationId) {
      this.landIDList = this.transformLandIDData(this.allLandsOfApplication);
    } else {
      if (this.applicationSelected === 'Individual') {
        this.getFarmerLandByFarmerIds();
      } else {
        this.loader.start();
        this.farmerAppSer.GetFarmerAndLandByVillageCode(villageCode).subscribe({
          next: (data) => {
            this.loader.close();
            if (data) {
              this.farmerDetailsList = data;
              this.getFarmerLandByFarmerIds();
            }
          },
          error: (err) => {
            this.loader.close();
            console.log(err);
          },
        });
      }
    }
  }

  getFarmerLandByFarmerIds() {
    let farmerIds = [];
    //Here for Individual application Type
    if (this.applicationSelected === 'Individual') {
      let farmerData: any = sessionStorage.getItem('farmerDetails');
      let farmerId = JSON.parse(farmerData).Farmer_ID;
      farmerIds.push(farmerId.toString());
    } else {
      let farmerData: any = sessionStorage.getItem('farmerDetails');
      let farmerId = JSON.parse(farmerData).Farmer_ID;
      farmerIds.push(farmerId.toString());
      this.selectedFarmersLandList?.forEach((x) => {
        farmerIds.push(x.farmer_Id?.toString());
      });
    }

    let villageCodes = [];
    villageCodes.push(this.selectedVillageCode.toString());
    let body = {
      farmerId: farmerIds,
      villageCode: villageCodes,
    };
    this.loader.start();
    this.farmerAppSer.GetFarmerLandByFarmerIds(body).subscribe({
      next: (data) => {
        this.loader.close();
        if (data.length) {
          this.landIDList = this.transformLandIDData(data);
          return;
        }
      },
      error: (err) => {
        this.loader.close();
        console.log(err);
        //this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Cannot Get Farmer lands for Selected Village.' });
      },
    });
  }

  getAllOutletData(villageCode: any) {
    this.loader.start();
    this.farmerAppSer.GetAllOutletDetails(villageCode).subscribe((res) => {
      of(...res)
        .pipe(
          groupBy((p: any) => p.canal),
          mergeMap((group$) =>
            group$.pipe(reduce((acc, cur) => [...acc, cur], [`${group$.key}`]))
          ),
          map((arr) => ({ canal: arr[0], data: arr.slice(1) })),
          toArray()
        )
        .subscribe((p) => {
          this.loader.close();
          this.canalOutletList = p;
          if (this.applicationId) {
            this.onCanalOutletSelected({
              value: this.watercourseApplicatonForm.controls.canal.value,
            });
          }
        });
    });
  }

  onCanalOutletSelected(event) {
    let selected = event.value;
    this.outletTypeList = [];
    let selectedAppData = this.canalOutletList?.filter(
      (d) => d.canal === selected
    )[0].data;
    this.outletTypeList = selectedAppData;
    if (!this.applicationId) {
      if (
        this.selectedWatersourceType == 'Canal' ||
        this.selectedWatersourceType == 'STP'
      ) {
        this.landIDList = this.selectedLandIdList?.filter(
          (x) => x.Village_Code == this.outletTypeList[0].villageCode
        );
      } else {
        this.landIDList = this.selectedLandIdList;
      }
    }
  }

  transformLandIDData(inputData) {
    return inputData?.map((r) => {
      return {
        ...r,
        displayName:
          'Village Name:' +
          (r.VillageName ? r.VillageName : this.selectedVillageName) +
          ' - Killa No:' +
          ((r.Killa_No ? r.Killa_No : r.killaNo)
            ? r.Killa_No
              ? r.Killa_No
              : r.killaNo
            : r.KillaNo) +
          ' - Morabba No:' +
          ((r.Morabba_No ? r.Morabba_No : r.morabbaNo)
            ? r.Morabba_No
              ? r.Morabba_No
              : r.morabbaNo
            : r.MorabbaNo),
      };
    });
  }

  get watercourseFormControls() {
    return this.watercourseApplicatonForm.controls;
  }

  onWaterSourceTypeSelected(event) {
    this.selectedWatersourceType = event.value;
    // this.componentSelected.Scheme_ID = '';
    // this.componentSelected.component = '';
    let selectedWaterSourceData = this.waterSourceTypeList.filter(
      (d) => d.waterSource === this.selectedWatersourceType
    )[0].component;
    this.componentList = selectedWaterSourceData
      .map((d) => {
        let keys = ['MI', 'Solar', 'Pond', 'Water_Course'];
        let filtered = keys.filter((r) => d[r] === true);
        return { component: filtered.join('+'), Scheme_ID: d.Scheme_ID };
      })
      .filter((r) => r.component && r.Scheme_ID);
    console.log('componentList', this.componentList);
  }

  onComponentSelected(event) {
    let selected = event.value;
    this.componentSelected = selected;
    console.log('componentSelected', this.componentSelected);
  }

  addFarmersInGroup() {
    // this.bankAccount = {};
    // this.submitted = false;
    this.addFarmerGroupDialog = true;
  }

  openPreviousConsent(url) {
    window.open(url, '_blank');
  }

  downloadConsent() {
    window.open('/assets/consent.pdf', '_blank');
  }

  editFarmersInGroup(ele) {
    this.addFarmerGroupDialog = true;
  }

  openNew() {
    // this.bankAccount = {};
    // this.submitted = false;
    this.miApplicatonForm.reset();
    this.getFarmerLandByFarmerIds();
    this.addBankDialog = true;
  }

  onCapacityOfPumpSelected(event) {
    if (!this.solarApplicatonForm.controls.controlType.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! SOLAR FORM - controlType Cant be Empty',
      });
      return;
    } else if (!this.solarApplicatonForm.controls.pump.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! SOLAR FORM - pump Cant be Empty',
      });
      return;
    } else if (!this.solarApplicatonForm.controls.pumpType.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! SOLAR FORM - pumpType Cant be Empty',
      });
      return;
    } else if (!this.solarApplicatonForm.controls.pumpCapacity.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! SOLAR FORM - pumpCapacity Cant be Empty',
      });
      return;
    } else if (!this.solarApplicatonForm.controls.landId.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! SOLAR FORM - landId Cant be Empty',
      });
    }

    this.validateAndGetSolarVendors();
  }

  getBankListOfFarmer() {
    let farmerData: any = sessionStorage.getItem('farmerDetails');
    let appNo = JSON.parse(farmerData).Farmer_ID;
    this.loader.start();
    this.productService.getBankDetails(appNo).subscribe((res) => {
      this.loader.close();
      this.bankAccountListForEditApp = res.map((r) => {
        return { ...r, displayName: r.Account_NO + ' - ' + r.Bank_NAME };
      });
    });
  }

  getSolarMaster() {
    this.loader.start();
    this.farmerAppSer.getSolarMaster().subscribe({
      next: (data) => {
        if (data) {
          this.loader.close();
          this.solarMasterData = data;
        }
      },
      error: (err) => {
        this.loader.close();
        console.log(err);
      },
    });
  }

  validateAndGetSolarVendors() {
    if (
      this.solarApplicatonForm.controls.controlType.value &&
      this.solarApplicatonForm.controls.pump.value &&
      this.solarApplicatonForm.controls.pumpType.value &&
      this.solarApplicatonForm.controls.pumpCapacity.value
    )
      this.getPrimarySolarVendors();
  }

  getPrimarySolarVendors() {
    this.primarySolarVendorList = [];

    let solarMasteredFilteredData = this.getFarmerShare();
    if (solarMasteredFilteredData) {
      this.solarApplicatonForm.patchValue({
        farmerShare: solarMasteredFilteredData.Farmers_Share,
      });
      this.solarApplicatonForm.patchValue({
        solarId: solarMasteredFilteredData.Solar_ID,
      });
      this.loader.start();
      this.farmerAppSer
        .getPrimarySolarVendors(solarMasteredFilteredData.Solar_ID)
        .subscribe({
          next: (data) => {
            this.loader.close();
            if (data) {
              this.primarySolarVendorList = data;
              if (this.applicationId) {
                this.onPrimarySolarVendorChange({
                  value: this.selectedPrimarySolarVendor,
                });
              }
            }
          },
          error: (err) => {
            this.loader.close();
            console.log(err);
          },
        });
    } else {
      this.loader.close();
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! Solar ID Not Found For selected Combination',
      });
    }
  }

  onPrimarySolarVendorChange(event) {
    this.selectedPrimarySolarVendor = event.value;
    let solarMasteredFilteredData = this.getFarmerShare();
    console.log(this.primarySolarVendorList);
    let selectedPrimaryVendor = this.primarySolarVendorList.filter((vendor) => {
      return vendor.Primary_Vendor === event.value;
    });
    if (selectedPrimaryVendor.length) {
      this.getSecondarySolarVendors(selectedPrimaryVendor[0].pid);
    } else {
      this.loader.close();
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail:
          'PID value is unknown for Selcted Primary Vendor, Hence Secondary Vendor is not known',
      });
      return;
    }
  }

  getSecondarySolarVendors(solarId: any) {
    this.loader.start();
    this.farmerAppSer.getSecondarySolarVendors(solarId).subscribe({
      next: (data) => {
        this.loader.close();
        if (data) {
          this.secondarySolarVendorList = data;
          if (this.selectedSecondarySolarVendor) {
            let selectedSolarVendor = this.secondarySolarVendorList.filter(
              (x) => {
                return x.Secondary_Vendor === this.selectedSecondarySolarVendor;
              }
            );
            this.selectedSecondarySolarVendorId = selectedSolarVendor[0].sid;
          }
        }
      },
      error: (err) => {
        this.loader.close();
        console.log(err);
      },
    });
  }

  onSecondarySolarVendorChange(event) {
    this.selectedSecondarySolarVendor = event.value;
    let selectedSolarVendor = this.secondarySolarVendorList.filter((x) => {
      return x.Secondary_Vendor === this.selectedSecondarySolarVendor;
    });
    this.selectedSecondarySolarVendorId = selectedSolarVendor[0].sid;
  }

  getFarmerShare() {
    return this.solarMasterData.filter(
      (d: any) =>
        d.Pump_Controler_Type ===
          this.solarApplicatonForm.value['controlType'] &&
        d.Pump_Capacity === this.solarApplicatonForm.value['pumpCapacity'] &&
        d.Pump_Category === this.solarApplicatonForm.value['pumpType'] &&
        d.Pump_Type === this.solarApplicatonForm.value['pump']
    )[0];
  }

  onSolarLandIdSelected(event) {}

  get solarApplicatonFormControls() {
    return this.solarApplicatonForm.controls;
  }

  onCoverageAreaSelected(event) {
    this.coverageAreaSelected = event.value;
    this.onFarmPondApplicatonForm.patchValue({
      topSize: this.coverageAreaSelected.Top_Size,
      bottomSize: this.coverageAreaSelected.Bottom_Size,
      depth: this.coverageAreaSelected.Depth,
      waterCapacity: this.coverageAreaSelected.Water_Capacity,
      tenativeCost: this.coverageAreaSelected.Total_Cost,
      tankId: this.coverageAreaSelected.Tank_ID,
    });
  }

  getAllTank() {
    this.loader.start();
    this.farmerAppSer.getAllTank().subscribe({
      next: (data) => {
        this.loader.close();
        this.tankListMaster = data;
      },
      error: (err) => {
        this.loader.close();
        console.log(err);
      },
    });
  }

  get farmPondApplicatonFormControls() {
    return this.onFarmPondApplicatonForm.controls;
  }

  deleteProduct(ele) {
    this.loader.start();
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.loader.close();
        this.miDetailsList = this.miDetailsList.filter(
          (val) => val.landId !== ele.landId
        );
      },
    });
  }

  editProduct(ele) {
    this.miApplicatonForm.reset();
    this.miApplicatonForm.patchValue({
      landId: ele.landId,
      // landId: this.landIDList.filter(r => r.Land_ID === ele.landId)[0].displayName,
      mi: ele.mi,
      vendor: ele.vendorId,
    });
    this.addBankDialog = true;
  }

  onBankAccountSelected(event) {
    this.bankAccountSelected = event.value;
  }

  getPastSubsidiesByFarmerId() {
    this.loader.start();
    if (this.farmerId) {
      this.ofService
        .GetFarmerPastSubsidyByFarmerId(this.farmerId)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.loader.close();
            this.farmerPreviousSubsidies = data;
          },
          error: () => {
            this.loader.close();
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Data error! Farmer Previous Subsidies not loaded.',
            });
          },
        });
    }
  }

  getWorkTypeMasterData() {
    this.farmerAppSer.GetWorktypeMaster().subscribe((res) => {
      this.workTypeMasterList = res;
    });
  }

  resetApplication() {
    this.solarApplicatonForm.reset();
    this.onFarmPondApplicatonForm.reset();
    this.miDetailsList = [];
  }

  getVillageData() {
    this.loader.start();
    this._personalDetalSer.getVillageMatserData().subscribe((res) => {
      this.loader.close();
      this.villageList = res;
      this.filteredVillage = [...this.villageList];
      if (!window.sessionStorage.getItem('villageMaster')) {
        window.sessionStorage.setItem('villageMaster', JSON.stringify(res));
      }
    });
    console.log(this.villageList);
  }
  

  postFarmersRegistrationDataForChangeReq(farmersApplicationToSubmit) {
    this.loader.start();
    this.farmerAppSer  
      .changeReqSubmitApplication(farmersApplicationToSubmit)
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data.startsWith('S:')) {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data,
            });
            this.showEditAppDetailsCard = false;
            this.resetApplication();
            // setTimeout(() => {
            //   this.router.navigate(['dashboard']);
            // }, 1000);
          } else {
            this.loader.close();
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: data,
            });
          }
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Farmer Application not saved.',
          });
        },
      });
  }

  onFarmersApplicationFormSubmit() {
    // console.log("miDetailsList", this.miDetailsList, this.miDetailsList.length == 0);
    // console.log("componentSelected", this.componentSelected);
    // console.log("coverageAreaSelected", this.coverageAreaSelected['Tank_ID'] );
    // console.log("coverageAreaSelected", this.coverageAreaSelected);
    // console.log("bankAccountSelected", this.bankAccountSelected);
    // console.log("solarApplicatonForm", this.solarApplicatonForm.value)

    // check validations
    if (this.componentSelected.component.includes('MI')) {
      if (this.miDetailsList.length == 0) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message! MI list is empty',
          detail: 'Please Add MI details first',
        });
        return;
      }
    }

    if (this.componentSelected.component.includes('Pond')) {
      if (this.onFarmPondApplicatonForm.invalid) {
        this.isSubmittedPondApplicatonForm = true;
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message! Invalid',
          detail: 'Please Fill Pond Application Form Properly.',
        });
        return;
      }
    }

    if (this.componentSelected.component.includes('Solar')) {
      if (this.solarApplicatonForm.invalid) {
        this.isSubmittedSolarApplicatonFrom = true;
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message! Invalid',
          detail: 'Please Fill Solar Application Form Properly.',
        });
        return;
      }
    }

    //gettting primary solar vendor Id
    let filteredPrimarySolarVendor: any = this.primarySolarVendorList.filter(
      (x) => x.Primary_Vendor === this.selectedPrimarySolarVendor
    );

    //Populating Water
    let waterCouseDetail = [];
    if (
      this.selectedWatersourceType == 'Canal' ||
      this.selectedWatersourceType == 'STP'
    ) {
      if (this.watercourseApplicatonForm.invalid) {
        this.isSubmittedWaterCourseFrom = true;
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message! Invalid',
          detail: 'Please Fill  Water Course Form Properly.',
        });
        return;
      } else {
        let body = {
          outlet_Code: this.watercourseApplicatonForm.controls.outlet.value,
          work_type: this.watercourseApplicatonForm.controls.workType.value,
        };
        waterCouseDetail.push(body);
      }
    }

    //validation for bank details
    if (
      this.bankAccountSelected == undefined ||
      this.bankAccountSelected == null
    ) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message! Invalid',
        detail: 'Please Select the Bank Details.',
      });
      return;
    }

    //Validation for Group: Consent Form Path shouldnt be null
    if (this.applicationSelected === 'Group') {
      if (!this.consentUploadPath) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Please upload Consent Form',
        });
        return;
      }
    }

    //Validate if Total subsidy area is less than 12.5
    let totalSubsidyArea = 0;
    this.miDetailsList.forEach((mi) => {
      totalSubsidyArea = totalSubsidyArea + Number(mi.totalArea);
    });
    this.farmerPreviousSubsidies.forEach((subsidy) => {
      if (subsidy.DiffYear < 8) {
        totalSubsidyArea = totalSubsidyArea + Number(subsidy.Area);
      }
    });
    //For Group Application, the total max subsidy allowed is calculated by No. of Farmer in Group Multiplied by '12.5' and Subtracting farmer previous subsidies from last 8 years
    if (this.applicationSelected === 'Group') {
      let maxSubsidyAreaForGroup = this.totalNumberOfFarmersInGroup * 12.5;
      if (maxSubsidyAreaForGroup > 0) {
        if (totalSubsidyArea > maxSubsidyAreaForGroup) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail:
              'Total Area Eligible for subsidy should be Less than ' +
              Number(maxSubsidyAreaForGroup) +
              'Acre .For ' +
              this.totalNumberOfFarmersInGroup +
              'Farmers (Group Application). You are applying for ' +
              Number(totalSubsidyArea) +
              ' Acre. \n\n Contact Department',
          });
          return;
        }
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail:
            'Max SubSidy Area Cant be calculated for Group. Contact Department',
        });
        return;
      }
    } else {
      if (totalSubsidyArea > 12.5) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail:
            'Total Area Eligible for subsidy should be Less than 12.5 Acre. You are applying for ' +
            Number(totalSubsidyArea) +
            ' Acre. \n\n Contact Department',
        });
        return;
      }
    }

    let totalArea = 0;
    this.miDetailsList.forEach((mi) => {
      totalArea = totalArea + Number(mi.totalArea);
    });
    //Validation for 'MI' if total area is less than 1 acre
    if (Number(totalArea) < 1 && Number(totalArea) != 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail:
          'Data error! Total Area for MI form cannot be less than 1 Acre. ' +
          Number(totalArea),
      });
      return;
    }
    //Validation for 'Pond' if total area is less than 5 acre
    if (this.componentSelected.component.includes('Pond')) {
      if (Number(totalArea) < 5 && Number(totalArea) != 0) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail:
            'Data error! Total Area for Pond form cannot be less than 5 Acre.Current Total Area is ' +
            Number(totalArea),
        });
        return;
      }
    }


    let farmerData: any = sessionStorage.getItem('farmerDetails');
    let appNo = JSON.parse(farmerData).Farmer_ID;
    let farmersApplicationToSubmit = {
      apP_ID: this.applicationId ? this.applicationId : '',
      farmer_ID: appNo,
      applicant_type: this.applicationSelected,
      scheme_Code: this.componentSelected.Scheme_ID,
      user_ID: sessionStorage.getItem('abyUserID')
        ? sessionStorage.getItem('abyUserID')
        : sessionStorage.getItem('userID'),
      is_Atal:
        sessionStorage.getItem('isAtalBhujal') === '1' ||
        sessionStorage.getItem('isVendor') === '1'
          ? true
          : false,
      netWork_Id: this.ipAddress,
      terminal_Id: this.ipAddress,
      consentPath: this.consentUploadPath ? this.consentUploadPath : '',
      group_Datas: this.selectedGroupFarmersLandList,
      water_Course_Datas: waterCouseDetail,
      onFarm_Pond_Datas: this.componentSelected.component.includes('Pond')
        ? [
            {
              land_ID: this.onFarmPondApplicatonForm.value['landId'],
              tank_id: this.onFarmPondApplicatonForm.value['tankId'],
            },
          ]
        : [],
      solar_Pump_Datas: this.componentSelected.component.includes('Solar')
        ? [
            {
              solar_ID: +this.solarApplicatonForm.value['solarId'],
              solar_Vendor_id: filteredPrimarySolarVendor[0].pid,
              solar_Vendor_Secondry_ID: this.selectedSecondarySolarVendorId,
              land_ID: this.solarApplicatonForm.controls.landId.value,
            },
          ]
        : [],
      new_MI_Datas: this.miDetailsList.map((r) => {
        return {
          // new_MI_System: this.miList.filter(
          //   (res) => res.Program_Name === r.mi
          // )[0]?.Program_Id,
          land_ID: r.landId,
          new_MI_System: r.mi,
          vendor_Code: r.vendorId?.Vendor_Code
            ? r.vendorId?.Vendor_Code
            : r.vendorCode,
        };
      }),
      bank_Datas: [
        {
          bank_Data: this.bankAccountSelected?.toString(),
        },
        // {
        //   "farmer_ID": appNo,
        //   "bank_ID": this.bankAccountSelected
        // }
      ],
    };
    
    this.postFarmersRegistrationDataForChangeReq(farmersApplicationToSubmit);
  }

  saveFarmerToGroup() {
    this.selectedFarmersLandList = [];
    this.selectedGroupFarmersLandList = [];
    console.log(this.selectedFarmerLandDetails);
    if (this.applicationSelected === 'Group') {
      let farmerIds = [];
      this.selectedFarmerLandDetails.forEach((farmer) => {
        farmerIds.push(farmer.Farmer_ID.toString());
      });
      this.totalNumberOfFarmersInGroup = farmerIds.length;
      if (farmerIds.length) {
        this.loader.start();
        this.ofService
          .GetFarmerPastSubsidyByMultipleFarmerIds(farmerIds)
          .pipe(first())
          .subscribe({
            next: (data) => {
              this.loader.close();
              this.farmerPreviousSubsidies = data;
            },
            error: () => {
              this.loader.close();
              this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: 'Data error! Farmer Previous Subsidies not loaded.',
              });
            },
          });
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Data error! Group-Farmers Previous Subsidies not Fetched.',
        });
        return;
      }
    }
    this.selectedFarmerLandDetails.forEach((r) => {
      r.landDetails.forEach((element) => {
        // this.selectedFarmersLandList.push({
        //   "farmer_Id": element.Farmer_ID ? element.Farmer_ID : element.farmerId,
        //   "landID": element.Land_ID ? element.Land_ID : element.LandID,
        //   "farmersName": r.Name,
        //   "village": r.vendorId ? r.venorId : r.Village_Code
        // })
        // this.selectedGroupFarmersLandList.push({
        //   "farmer_Id": element.Farmer_ID ? element.Farmer_ID : element.farmerId,
        //   "landID": element.Land_ID ? element.Land_ID : element.LandID
        // })

        let filteredLands = this.selectedFarmersLandIdList.filter((x) => {
          return (
            x.Land_ID == (element.LandID ? element.LandID : element.Land_ID)
          );
        });

        if (filteredLands.length) {
          this.selectedFarmersLandList.push({
            farmer_Id: element.Farmer_ID ? element.Farmer_ID : element.farmerId,
            landID: element.Land_ID ? element.Land_ID : element.LandID,
            farmersName: r.Name,
            village: r.vendorId ? r.venorId : r.Village_Code,
          });
          this.selectedGroupFarmersLandList.push({
            farmer_Id: element.Farmer_ID ? element.Farmer_ID : element.farmerId,
            landID: element.Land_ID ? element.Land_ID : element.LandID,
          });
        }
      });
    });
    this.addFarmerGroupDialog = false;
  }

  hideFarmersAddToGroupDialog() {
    this.addFarmerGroupDialog = false;
  }

  selectRow(checkValue, data) {
    if (checkValue) {
      let index = this.selectedFarmersLandIdList.indexOf(data);
      if (index == -1) {
        this.selectedFarmersLandIdList.push(data);
      }
    } else {
      let index = this.selectedFarmersLandIdList.indexOf(data);
      if (index !== -1) {
        this.selectedFarmersLandIdList.splice(index, 1);
      }
    }
  }

  selectHeaderRow(checkValue, data) {
    if (checkValue) {
      data.forEach((element) => {
        let index = this.selectedFarmersLandIdList.indexOf(element);
        if (index == -1) {
          this.selectedFarmersLandIdList.push(element);
        }
      });
    } else {
      data.forEach((element) => {
        let index = this.selectedFarmersLandIdList.indexOf(element);
        if (index !== -1) {
          this.selectedFarmersLandIdList.splice(index, 1);
        }
      });
    }
  }

  saveProduct() {
    // mi: [''],
    // vendor: [''],
    // landId: ['']

    let vendorName = this.miVendorList.filter(
      (x) =>
        x.Vendor_Code == this.miApplicatonForm.value['vendor']['Vendor_Code']
    )[0]?.Name;
    let filteredLand = this.landIDList.filter((x) => {
      return x.LandID == this.miApplicatonForm.value['landId'];
    });
    console.log('Filtered Land', filteredLand);
    let miFarmValue = {
      mi: this.miApplicatonForm.value['mi'],
      vendor: vendorName,
      landId: this.miApplicatonForm.value['landId'],
      vendorId: this.miApplicatonForm.value['vendor'],
      landData: filteredLand[0]?.displayName,
      totalArea: filteredLand[0]?.TotalArea,
    };

    this.miDetailsList = this.miDetailsList.filter(
      (val) => val.landId !== miFarmValue.landId
    );

    this.miDetailsList.push(miFarmValue);
    this.miApplicatonForm.reset();
    this.addBankDialog = false;
  }

  hideDialog() {
    this.miApplicatonForm.reset();
    this.addBankDialog = false;
  }

  onVendorSelect(event) {}

  filterMIVendor(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.miVendorList.length; i++) {
      const vendor = this.miVendorList[i];
      if (vendor.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(vendor);
      }
    }
    this.filteredmiVendorList = filtered;
  }

  onSelectMI() {
    console.log('programId', this.selectedMI);
    this.selectedProgramId = this.selectedMI;
    this.getAllMIvenders(this.selectedMI);
  }

  getSchemeMaster() {
    this.loader.start();
    this.farmerAppSer.getSchemeMaster().subscribe((res) => {
      this.loader.close();
      this.allSchemeMaster = res;
      of(...res)
        .pipe(
          groupBy((p: any) => p.Applicant_type),
          mergeMap((group$) =>
            group$.pipe(reduce((acc, cur) => [...acc, cur], [`${group$.key}`]))
          ),
          map((arr) => ({ type: arr[0], data: arr.slice(1) })),
          toArray()
        )
        .subscribe((p) => {
          this.schemeMasterList = p;
        });
    });
  }


  getAllMIvenders(programId) {
    this.loader.start();
    this.farmerAppSer
      .getAllMIvenders(programId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          console.log('All MI Vendor Data', res);
          this.miVendorList = res;
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Category not loaded.',
          });
        },
      });
  }

  getComponentMaster() {
    this.loader.start();
    this.farmerAppSer.getComponentMaster().subscribe((res) => {
      this.loader.close();
      console.log('componentMaster', res);
      this.componentMaster = res;
      this.miList = res;
    });
  }

  onPondLandIdSelected(event) {
    this.selectedPondLand = event.value;
  }

  populateForm(appId) {
    this.loader.start();
    this._dashboardService
      .getApplicationByAppId(appId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data.APP_ID) {
            //Populating Farmer Application Form
            if (data.FarmerLand) {
              this.landIDList = [];
              this.allLandsOfApplication = data.FarmerLand;
              this.landIDList = this.transformLandIDData(data.FarmerLand);
              console.log(this.landIDList)
            }
            if (data.Scheme_ID) {
              this.selectedSchemeId = data.Scheme_ID;
              const populatedScheme = this.allSchemeMaster.filter(
                (x) => x.Scheme_ID === data.Scheme_ID
              );

              this.onApplicationTypeSelected({
                value: populatedScheme[0].Applicant_type,
              });
              this.onVillageSelect({
                Code: data.VillageData[0].VillageCode,
                Name: data.VillageData[0].VillageName,
              });
              this.onWaterSourceTypeSelected({
                value:
                  this.waterSourceTypeList[populatedScheme[0].Water_Source - 1]
                    .waterSource,
              });
              const populatedComponent = this.componentList.filter(
                (x) => x.Scheme_ID === data.Scheme_ID
              );
              this.onComponentSelected({ value: populatedComponent[0] });
              console.log("selectedWatersourceType", this.selectedWatersourceType)
              console.log("componentSelected", this.componentSelected)
            }
            if (data.ConsentPath) {
              this.consentUploadPath = data.ConsentPath;
            }
            //populating Farmer Details
            if (data.Group_Datas) {
              data.Group_Datas.forEach((x) => {
                x.landDetails = data.FarmerLand.filter((land) => {
                  return land.farmerId === x.Farmer_ID;
                });
                this.selectedFarmerLandDetails.push(x);
              });
              data.GroupTableData.forEach((x) => {
                this.selectedFarmersLandIdList.push({ Land_ID: x.LandID });
              });
              this.saveFarmerToGroup();
              // this.selectedFarmersLandList = data.GroupTableData;
            }

            //Populating MI Data
            this.miDetailsList = [];
            if (data.New_MI_Datas) {
              data.New_MI_Datas.forEach((x) => {
                let filteredList = this.miVendorList.filter((vendor) => {
                  return vendor.Name == x.miVendorName;
                });
                this.miSelectedVendor = filteredList[0];
                

                let component = 0;
                this.componentMaster.forEach((val) => {
                  if( x.programName == val.Program_Name){
                    component =  val.Program_Id;
                  }
                })

                let body = {
                  mi: component,
                  vendor: x.miVendorName,
                  landId: x.LandID,
                  vendorCode: x.VendorCode,
                  vendorObject: filteredList[0],
                  landData: x.landData,
                  totalArea: x.totalArea,
                };
                this.miDetailsList.push(body);
              });
            }

            //populating Bank
            this.onBankAccountSelected({
              value: data.FarmerBank?.accoNumber?.toString(),
            });

            //Populating Pond Farm
            if (data.OnFarm_Pond_Datas) {
              // let selectedLand = this.landIDList.filter((x) => {
              //   return x.Land_ID === data.OnFarm_Pond_Datas[0].LandID;
              // });
              let selectedLand = data.OnFarm_Pond_Datas;
              this.onPondLandIdSelected({ value: selectedLand[0] });
              this.onFarmPondApplicatonForm.controls.landId.setValue(
                selectedLand[0].Land_ID
              );

              let filteredTankMaster = this.tankListMaster.filter((x) => {
                return (
                  x.Coverage_Area == data.OnFarm_Pond_Datas[0].CoverageArea
                );
              });
              this.onCoverageAreaSelected({ value: filteredTankMaster[0] });
            }

            //populating Solar Form
            if (data.Solar_Pump_Datas) {
              // let selectedLand = this.landIDList.filter((x) => {
              //   return x.Land_ID === data.Solar_Pump_Datas[0].LandID;
              // });
              let selectedLand = data.Solar_Pump_Datas;
              this.solarApplicatonForm.controls.landId.setValue(
                selectedLand[0].Land_ID
              );
              this.solarApplicatonForm.controls.controlType.setValue(
                data.Solar_Pump_Datas[0].controlerType
              );
              this.solarApplicatonForm.controls.pump.setValue(
                data.Solar_Pump_Datas[0].type
              );
              this.solarApplicatonForm.controls.pumpType.setValue(
                data.Solar_Pump_Datas[0].pumpCategory
              );
              this.solarApplicatonForm.controls.pumpCapacity.setValue(
                data.Solar_Pump_Datas[0].pumpCapacity
              );
              this.validateAndGetSolarVendors();
              this.selectedPrimarySolarVendor =
                data.Solar_Pump_Datas[0].primaryVendor;
              this.selectedSecondarySolarVendor =
                data.Solar_Pump_Datas[0].secondaryVendor;

              this.solarApplicatonForm.controls.farmerShare.setValue(
                data.Solar_Pump_Datas[0].farmerShare
              );
            }

            if (data?.Water_Course_Datas) {
              this.watercourseApplicatonForm.controls.canal.setValue(data?.Water_Course_Datas[0]?.Canal_Outlet_Name);
              this.watercourseApplicatonForm.controls.outlet.setValue(data?.Water_Course_Datas[0]?.Outlet_Code);
              this.watercourseApplicatonForm.controls.workType.setValue(data?.Water_Course_Datas[0]?.Work_type);
              console.log(this.watercourseApplicatonForm.controls)
            }



          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Data error! Requested Application Not Found.',
            });
            return;
          }
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Requested Application Not Found.',
          });
          return;
        },
      });
  }

  //-------------------------------------------------------------------------------------

  getIP() {
    this.ipService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }
}
